const endpointSetter = (endpoint: string) => (a?: number | string, b?: number | string) =>
  `${endpoint}${a ? `/${a}` : ''}${b ? `/${b}` : ''}`

export { endpointSetter }
